// extracted by mini-css-extract-plugin
export var cardPadding = "_ae-0";
export var itemContainer = "_ae-1";